export default "__VITE_PUBLIC_ASSET__53b11293__"